import React, { useState, useEffect, useContext } from "react";
import "./Login_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Success_Modal_2 from "../success_modal2/Success_Modal_2";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import Login_Form from "./Login_Form";
import Sign_Up_Form from "./Sign_Up_Form";
import Forgot_Password from "./Forgot_Password";

function Login_Modal({ baseLink, ...props }) {
  const [modalShow, setModalShow] = useState(false);

  const [formType, setFormType] = useState("login");
  const [successText, setSuccessText] = useState("");

  return (
    <>
      <section className="Login_Modal modal-holder">
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="Login_Modal modal-holder"
        >
          <Modal.Body>
            <div className="content_div">
              <div
                className="back_holder"
                onClick={() => {
                  props?.onHide();
                }}
              >
                <FontAwesomeIcon icon={faAngleLeft} className="inner_icon" />
              </div>

              {formType === "login" ? (
                <Login_Form
                  onHide={() => props?.onHide()}
                  setSuccessModalShow={setModalShow}
                  setFormType={setFormType}
                  setSuccessText={setSuccessText}
                />
              ) : formType === "signup" ? (
                <Sign_Up_Form
                  onHide={() => props?.onHide()}
                  setSuccessModalShow={setModalShow}
                  setFormType={setFormType}
                  setSuccessText={setSuccessText}
                />
              ) : formType === "forgot" ? (
                <Forgot_Password
                  onHide={() => props?.onHide()}
                  setSuccessModalShow={setModalShow}
                  setFormType={setFormType}
                  setSuccessText={setSuccessText}
                />
              ) : null}
            </div>
          </Modal.Body>
        </Modal>

        <Success_Modal_2
          show={modalShow}
          successText={successText}
          onHide={() => {
            setModalShow(false);
          }}
        />
      </section>
    </>
  );
}

export default Login_Modal;
